import type { ActiveExecutionStopView } from '../operationalContextFacade';
import type {
  ActiveOperationCargoLineProjection,
  ActiveOperationProjection
} from './types';
import type { CargoLineSummary } from '../operationalContextFacade';

function mapCargoLines(lines: CargoLineSummary[]): ActiveOperationCargoLineProjection[] {
  return lines.map((l) => ({
    cargoName: l.name,
    qty: l.quantity,
    weightKg: l.weightKg
  }));
}

export function buildActiveOperationProjection(
  active: ActiveExecutionStopView | null
): ActiveOperationProjection | null {
  if (!active) return null;

  const ctx = active.context;
  const appNumber = ctx.applicationNumbers[0] ?? null;

  return {
    operationType: active.typeLabel === 'Погрузка' ? 'loading' : 'unloading',
    status: active.statusLabel,
    statusKey: active.operationalState,
    stopId: active.stop.stopId,
    executionStopUid: active.stop.executionStopUid,
    stopLabel: active.stop.label,
    address: active.address,
    application: {
      id: active.stop.applicationId ?? null,
      number: appNumber,
      client: ctx.clientName,
      consignee: ctx.consigneeName
    },
    cargoSummary: mapCargoLines(ctx.cargoLines),
    loadedSummary: mapCargoLines(ctx.loadedLines),
    remainingSummary: mapCargoLines(ctx.remainingLines),
    totalPlaces: ctx.totalPlaces,
    totalWeightKg: ctx.totalWeightKg,
    plannedAt: active.plannedAt,
    actualAt: active.actualAt,
    progressPercent: active.progressPercent
  };
}
